import ArrowIcon from 'icon/chevron_right.svg';
import { CampaignBanner } from 'shared/atoms/common/campaign-banner';
import { usePageActive } from '~/utils/active/use-page-active';
import { ClickPosition } from '~/utils/click-position';
import useReflowClick from '~/utils/use-reflow-click';

import './style.scss';

interface CampaignBannerItemProps {
  campaign: CampaignBanner;
}

export const CampaignBannerItem = (props: CampaignBannerItemProps): JSX.Element => {
  const { campaign } = props;
  const { title, bannerUrl, campaignId } = campaign;
  const active = usePageActive({ isBanner: true });

  const handleClick = useReflowClick(
    {
      clickEvent: (_, bundle) => ({
        ...bundle,
        current_position: ClickPosition.activity_banner,
      }),
      defaultBehavior: () => {
        active({
          schemaOption: {
            pageType: 'feed',
            categoryId: 0,
          },
          ampExtra: {
            enter_position: ClickPosition.activity_banner,
            enter_page_click_id: campaignId,
          },
        });
      },
    },
    [active],
  );

  return (
    <div className="campaign_item" onClick={handleClick}>
      <div className="campaign_item_body">
        <img src={bannerUrl} alt={title} />
      </div>
      <div className="campaign_item_footer">
        <p className="campaign_item_footer_desc">{title}</p>
        <ArrowIcon className="campaign_item_footer_arrow" />
      </div>
    </div>
  );
};
